module.exports = new __parcel__URL__("penguin.6577e559.svg").toString();